import type { ComponentStyleConfig } from '@chakra-ui/theme';

export const styleConfig: ComponentStyleConfig = {
  baseStyle: {
    px: {
      base: '5',
      md: '8',
    },
    pt: {
      base: '0',
      md: '8',
    },
    pb: '8',
    flex: '1',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
};
